export interface SubscriptionPlan {
  idMonthly: string;
  idAnnual: string;
  nameMonthly: string;
  nameAnnual: string;
  priceMonthly: number;
  priceAnnual: number;
  features: string[];
  stripePriceIdMonthly: string;
  stripePriceIdAnnual: string;
  // RevenueCat package identifiers — must match identifiers in RC Dashboard > Offerings
  rcPackageIdMonthly: string;
  rcPackageIdAnnual: string;
  popular?: boolean;
  comingSoon?: boolean;
}

// test prod codes
// Basic Monthly    - prod_TP5zMIZeh0ojgC
// Pro Monthly      - prod_TP60yu8Z1JJ46H
// Premium Monthly  - prod_TP61ZEt5OOEb56
// Basic Annual     - prod_TP5zhzzIMImxX0
// Pro Annual       - prod_TP60sqeK5XJvha
// Premium Annual   - prod_TP61enH49ttmZr

export const plans: SubscriptionPlan[] = [
  {
    idMonthly: "basic_monthly",
    idAnnual: "basic_annual",
    nameMonthly: "Basic",
    nameAnnual: "Basic",
    priceMonthly: 9.99,
    priceAnnual: 99.99,
    stripePriceIdMonthly: "price_1RuNthDp8jvphDnHQOAYNSA4", //"price_1SSHn9Dp8jvphDnHZ2A8hcUB",
    stripePriceIdAnnual: "price_1TO6xBDp8jvphDnHiz6QyTJq", //price_1SSHneDp8jvphDnHUAV5oZVQ",
    // RC package identifiers — verify these match your RC Dashboard > Offerings
    rcPackageIdMonthly: "Basic Monthly",
    rcPackageIdAnnual: "Basic Annual",
    features: [
      "Supports MLB, MLS, NBA, NCAAB, NCAAF, NFL, NHL",
      "Mobile Alerts",
      "Define up to 5 rules",
      "Mobile app access",
      "Email support",
    ],
  },
  {
    idMonthly: "pro_monthly",
    idAnnual: "pro_annual",
    nameMonthly: "Pro",
    nameAnnual: "Pro",
    priceMonthly: 19.99,
    priceAnnual: 199.99,
    stripePriceIdMonthly: "price_1RuNwzDp8jvphDnHqukGOoZu", //"price_1SSHoADp8jvphDnHqPcWUdeh",
    stripePriceIdAnnual: "price_1TO6wZDp8jvphDnHmBh3ucSK", //"price_1SSHodDp8jvphDnHnWGzjayU",
    // RC package identifiers — verify these match your RC Dashboard > Offerings
    rcPackageIdMonthly: "Pro Monthly",
    rcPackageIdAnnual: "Pro Annual",
    features: [
      "All Basic features",
      "Prop Betting Rules",
      "Unlimited Rules",
      "Expanded Rule Selections",
      "Priority support",
    ],
    popular: true,
  },
  {
    idMonthly: "premium_monthly",
    idAnnual: "premiun_annual",
    nameMonthly: "Premium",
    nameAnnual: "Premium",
    priceMonthly: 24.99,
    priceAnnual: 249.99,
    stripePriceIdMonthly: "price_1TO3viDp8jvphDnHanout0Ys", //"price_1SSHp0Dp8jvphDnHRexFM2Oz",
    stripePriceIdAnnual: "price_1RuNz9Dp8jvphDnHH3axJ3CJ",
    // RC package identifiers — verify these match your RC Dashboard > Offerings
    rcPackageIdMonthly: "Premium Monthly",
    rcPackageIdAnnual: "Premium Annual",
    features: [
      "All Pro features",
      "Realtime Arbitrage opportunites",
      "Realtime EV opportunites",
    ],
    // comingSoon: true,
  },
];
